import { EditExploreSubSectionForm } from "@/components/Explore";
import type { ExploreSubSection } from "@/types";
import { Modal } from "@/ui";
import type { ModalProps } from "@/ui";

type Props = Pick<ModalProps, "show" | "onClose"> & {
  subsection: ExploreSubSection;
};

export const EditExploreSubSectionModal = ({
  show,
  onClose,
  subsection,
}: Props) => {
  return (
    <Modal
      show={show}
      title="Edit Article"
      description="Update the article details below"
      onClose={onClose}
    >
      <EditExploreSubSectionForm subsection={subsection} onClose={onClose} />
    </Modal>
  );
};
